import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store/index'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '../public/css/main.css'
import DatetimePicker from 'vuetify-datetime-picker'
import VueCookie from 'vue-cookies';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.use(VueCookie);
Vue.use(DatetimePicker);
Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');

